import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostListener
} from '@angular/core';
import { SortType, SortDirection } from '../../constants-types/Enums';
import { SortInfo } from '../../core-data-model/SortInfo.model';

@Component({
    selector: '[sortable-header]',
    host: {
        '[class.sortableColumn]': 'sortType && sortState'
    },
    template: `
        <div class="layoutDefault layout--center">
            <div class="columnHeader">
                <ng-content></ng-content>
            </div>
            @if (sortType && sortState) {
                <span>
                    <i
                        class="fa"
                        [ngClass]="{
                            'fa-sort': !currentlySortingWith(sortType),
                            currentSortColumn: currentlySortingWith(sortType),
                            'fa-sort-up': sortDirectionIsAscending(sortType),
                            'fa-sort-down': sortDirectionIsDescending(sortType)
                        }"
                    >
                    </i>
                </span>
            }
        </div>
    `,
    standalone: false
})
export class SortableHeaderComponent {
    @Input('sortable-header')
    sortType: SortType;
    @Input()
    sortState: SortInfo[];

    @Output()
    sort: EventEmitter<SortType> = new EventEmitter();

    @HostListener('click', ['$event'])
    triggerSort(): void {
        if (this.sortState) {
            this.sort.emit(this.sortType);
        }
    }

    currentlySortingWith(sortType: SortType): boolean {
        if (this.sortState && this.sortState.length > 0) {
            return sortType === this.sortState[0].sortType;
        }
        return false;
    }

    sortDirectionIsAscending(sortType: SortType): boolean {
        return (
            this.currentlySortingWith(sortType) &&
            this.sortState[0].direction === SortDirection.Ascending
        );
    }
    sortDirectionIsDescending(sortType: SortType): boolean {
        return (
            this.currentlySortingWith(sortType) &&
            this.sortState[0].direction === SortDirection.Descending
        );
    }
}
